import { Box, Container, Typography, Button, Stack } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Section } from './Section';

interface DarkCalloutSectionProps {
  title: string;
  subtitle: string;
  items: string[];
  ctaLabel: string;
  ctaHref: string;
}

export function DarkCalloutSection({
  title,
  subtitle,
  items,
  ctaLabel,
  ctaHref,
}: DarkCalloutSectionProps) {
  return (
    <Section variant="dark" py={10}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography variant="h3" fontWeight={700} sx={{ mb: 2, color: 'white' }}>
          {title}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            color: 'rgba(255,255,255,0.8)',
            maxWidth: 600,
            mx: 'auto',
          }}
        >
          {subtitle}
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={3}
          justifyContent="center"
          sx={{ mb: 4 }}
        >
          {items.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                color: 'rgba(255,255,255,0.9)',
              }}
            >
              <CheckCircleIcon sx={{ color: 'primary.light', fontSize: 20 }} />
              <Typography variant="body2" fontWeight={500}>
                {item}
              </Typography>
            </Box>
          ))}
        </Stack>
        <Button
          variant="contained"
          size="large"
          href={ctaHref}
          sx={{
            bgcolor: 'white',
            color: 'primary.main',
            '&:hover': {
              bgcolor: 'grey.100',
            },
          }}
        >
          {ctaLabel}
        </Button>
      </Container>
    </Section>
  );
}
